import { Modal } from '../../../../components'
import { useAppDispatch } from '../../../../redux/hook'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'
import { deleteHoliday } from '../../api'
import { delholiday } from '../../slice/holidayslice'
import { DelHolidayIprops } from '../types'

const DeleteHoliday = ({ show, onClose, data }: DelHolidayIprops) => {
    const dispatch = useAppDispatch()
    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title="Delete Holiday"
            body={<p>Are you sure want to delete {data.title} holiday?</p>}
            defaultFooter={true}
            onSuccess={async () => {
                dispatch(SHOW_LOADER())
                try {
                    // Call the asynchronous function and wait for its result
                    await deleteHoliday(data.id)
                    dispatch(delholiday(data.id))

                    dispatch(
                        SHOW_NOTIFICATION({
                            message: 'Holiday deleted successfully',
                            type: 'success',
                        })
                    )

                    // You can also use the data received from the API if needed
                } catch (err) {
                    // Handle any errors here
                    console.error('Error fetching holidays:', err)
                } finally {
                    dispatch(HIDE_LOADER())
                }

                onClose(false)
            }}
        />
    )
}
export default DeleteHoliday
